"use client";

import clsx from "clsx";
import React from "react";
import {AnimatePresence, motion} from "framer-motion";
import FileAttachment from "../FileAttachment";
import {getScrollMaskStyle, type IncompatibleFile} from "./constants";

interface FileAttachmentsListProps {
   files: File[];
   scrollContainerRef: React.RefObject<HTMLDivElement | null>;
   onScroll: () => void;
   scrollState: {canScrollLeft: boolean; canScrollRight: boolean};
   incompatibleFiles: IncompatibleFile[];
   onRemoveFile: (index: number) => void;
}

const FileAttachmentsList: React.FC<FileAttachmentsListProps> = ({
   files,
   scrollContainerRef,
   onScroll,
   scrollState,
   incompatibleFiles,
   onRemoveFile,
}) => (
   <div
      className={clsx(
         "grid transition-[grid-template-rows] duration-200 ease-in-file",
         files.length > 0 ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
      )}
   >
      <div className="overflow-hidden">
         <div className="relative pt-2 pl-2">
            <div
               ref={scrollContainerRef}
               className="flex items-center gap-2 overflow-x-auto scrollbar-hide pb-1"
               onScroll={onScroll}
               style={getScrollMaskStyle(scrollState.canScrollLeft, scrollState.canScrollRight)}
            >
               <AnimatePresence mode="popLayout">
                  {files.map((file, index) => (
                     <motion.div
                        key={`${file.name}-${file.size}-${file.lastModified ?? index}`}
                        initial={{opacity: 0, scale: 0.93}}
                        animate={{opacity: 1, scale: 1}}
                        exit={{opacity: 0, scale: 0.93}}
                        transition={{duration: 0.2, ease: [0.16, 1, 0.3, 1]}}
                        className="flex-shrink-0"
                     >
                        <FileAttachment
                           file={file}
                           className="max-w-40 md:max-w-60"
                           onRemove={() => onRemoveFile(index)}
                           isIncompatible={incompatibleFiles.some((f) => f.index === index)}
                           incompatibilityReason={
                              incompatibleFiles.find((f) => f.index === index)?.reason
                           }
                        />
                     </motion.div>
                  ))}
               </AnimatePresence>
            </div>
         </div>
      </div>
   </div>
);

export default FileAttachmentsList;
